/*
 * @Descripttion: 
 * @version: 
 * @Author: wangliuyang
 * @Date: 2023-04-04 15:43:18
 * @LastEditors: wangliuyang
 * @LastEditTime: 2023-05-23 15:55:34
 */
export default function IsPC(){  
    var userAgentInfo = navigator.userAgent;
    var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");  
    var flag = true;  
    for (var v = 0; v < Agents.length; v++) {  
        if (userAgentInfo.indexOf(Agents[v]) > 0) { flag = false; break; }  
    }  

    if (/(iPhone|iOS|Android|iPad|iPod)/i.test(navigator.userAgent)) {
        // window.location.href ="https://m.gaosiedu.com";
    } 
    
    return flag;  
 }




// WEBPACK FOOTER //
// ./src/assets/js/switchWeb.js